import PriceManager from './PriceManager.vue';

export const priceManagerRoutes = [
  { path: 'price-manager', component: PriceManager, name: 'price-manager' }
];
